import React, { FormEvent, JSX, useReducer, useState, useEffect } from "react";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";

import { FormContainerState } from "../interfaces/FormContainerState";
import { formContainerReducer } from "../reducers/formContainerReducer";
import { isPhoneValid } from "../utils/isPhoneValid";
import { api } from "../utils/api";

import AppBar from "./AppBar";

import Form from 'react-bootstrap/Form';
import FormGroup from "./FormGroup";
import ModalWindow from "./ModalWindow";
import Spinner from "react-bootstrap/Spinner";
import SelectItem from "./SelectItem";
import {AvailableDay} from "../interfaces/AvailableDay";


export default function FormContainer(): JSX.Element {
    const INITIAL_STATE: FormContainerState = {
        status: "initial",
        fieldsValues: {
            email: "",
            date_visit: "",
            time_visit: "",
            name_surname: "",
            phone_number: "",
            car_brand_model: "",
            car_number: "",
            car_first_registration: "",
            vin_number: "",
            problem_description: ""
        },
        fieldsErrors: {
            date_visit: [],
            time_visit: [],
            phone_number: [],
        },
        available_days: [],
    };

    const [state, dispatch] = useReducer(formContainerReducer, INITIAL_STATE);
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const { executeRecaptcha } = useGoogleReCaptcha();

    useEffect(
        () => {
            dispatch({ ...state, status: "loading" })
            const response = api.get("/google_calendar_api/");
            response
            .then((res) => {
                dispatch({ ...state, status: "initial", available_days: res.data});
            })
            .catch(() => { dispatch({ ...state, status: "initial" }); });
        },
        []
    );

    const onChange = (
        e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>
    ) => {
        if(e.target.name === "phone_number") {
            if(!isPhoneValid(e.target.value)){
                dispatch({...state,
                    fieldsValues: { ...state.fieldsValues, phone_number: e.target.value },
                    fieldsErrors: { ...state.fieldsErrors, phone_number: ["Numer telefonu nie jest poprawny",] }
                });
                return;
            }
            else{
                dispatch({
                    ...state, fieldsValues: { ...state.fieldsValues, phone_number: e.target.value },
                    fieldsErrors: { ...state.fieldsErrors, phone_number: [] }
                });
            }
        }
        else {
            if(["date_visit", "time_visit",].includes(e.target.name)){
                dispatch({
                    ...state,
                    fieldsValues: { ...state.fieldsValues, [e.target.name]: e.target.value },
                    fieldsErrors: { ...state.fieldsErrors, [e.target.name]: [] }
                });
            }
            else {
                dispatch({...state, fieldsValues: { ...state.fieldsValues, [e.target.name]: e.target.value }});
            }
        }
    }

    const onSubmitHandler = async (e: FormEvent<HTMLFormElement> ) => {
        e.preventDefault();
        if (!executeRecaptcha) {
            console.log("Recaptcha not yet available");
            return;
        }

        const token = await executeRecaptcha("submit");

        try {
            dispatch({...state, status: "loading"});

            const response = await api.get("/google_calendar_api/");

            if(response.status === 200){
                const availableDays: Array<AvailableDay> = Array.from(response.data);
                const isDateAvailable = availableDays.filter(
                    (day: AvailableDay) => day.date === fieldsValues.date_visit
                );

                if(isDateAvailable.length > 0){
                    const isHourAvailable = isDateAvailable[0].hours.filter((hour: string) => hour === fieldsValues.time_visit + ":00");

                    if(isHourAvailable.length > 0){
                        try {
                            const response = await api.post("/google_calendar_api/", state.fieldsValues);
                            dispatch(INITIAL_STATE);

                            if(response.status === 200){
                                setIsOpen(true);
                            }
                        }
                        catch (error: any) {
                            dispatch({ ...state, status: "error" });
                            setIsOpen(true);
                        }
                    }
                    else {
                        dispatch({
                            ...state,
                            available_days: availableDays,
                            fieldsValues: {
                                ...state.fieldsValues,
                                time_visit: ""                            },
                            fieldsErrors: {
                                ...state.fieldsErrors,
                                time_visit: ["Ktoś zajął tę godzinę szybciej, wybierz inną z listy dostępnych"]
                            }
                        });
                    }
                }
                else {
                    dispatch({
                        ...state,
                        available_days: availableDays,
                        fieldsValues: {
                            ...state.fieldsValues,
                            date_visit: ""
                        },
                        fieldsErrors: {
                            ...state.fieldsErrors,
                            date_visit: ["Niestety ten dzień już nie jest dostępny, ktoś zajął go szybciej, wybierz inny z listy dostępnych",]
                        }
                    });
                }
            }
        }
        catch (error) {
            dispatch({ ...state, status: "error" });
            setIsOpen(true);
        }
    };

    const { fieldsValues, fieldsErrors } = state;

    const errorsArray: Array<string> = [
        ...fieldsErrors.phone_number,
        ...fieldsErrors.date_visit,
        ...fieldsErrors.time_visit
    ];

    if(state.status === "loading"){
        return (
            <div className={"container-fluid p-5"}>
                <div className={"row align-items-center justify-content-center p-5"}>
                    <Spinner animation={"grow"} variant={"success"} className={"m-1"}/>
                    <Spinner animation={"grow"} variant={"success"} className={"m-1"}/>
                    <Spinner animation={"grow"} variant={"success"} className={"m-1"}/>
                </div>
            </div>
        );
    }

    return (
        <div className={"row"} >
            <ModalWindow
                isOpen={isOpen}
                setIsOpen={setIsOpen}
                titleValue={state.status === "initial" ? "Sukces!" : "Operacja nie powiodła się"}
                bodyValue={state.status === "initial" ? "Operacja została ukończona pomyślnie" :
                    "Niestety nie udało się zarezerwować wizytę, prosimy spróbować później"
                }
            />
            <AppBar/>
            <div className={"container"} style={{ backgroundImage: "url('/Auto_Repair_shop_background.jpg')" }}>
                <div className={"row mt-2 justify-content-center align-items-center p-3"}
                >
                    <Form className={"col-md-6 col-12 p-3 bg-light border border-dark rounded-3"} method={"POST"} onSubmit={onSubmitHandler}>
                        <FormGroup labelValue={"Email"} inputType={"email"}
                                   inputName={"email"} inputValue={fieldsValues.email}
                                   onChange={onChange} required={true}
                        />
                        <SelectItem label={"Data"} optionLabel={"Wybierz datę"} fieldName={"date_visit"} options={
                            state.available_days.map((day) => day.date)
                        } onChange={onChange} fieldErrors={fieldsErrors.date_visit} />
                        <SelectItem label={"Godzina"} optionLabel={"Wybierz godzinę"} fieldName={"time_visit"}
                                    options={
                            fieldsValues.date_visit.length > 0 ? (
                                state.available_days.filter((day) => day.date === fieldsValues.date_visit)
                                .map((day) => day.hours)[0].map(
                                    (hour: string) => hour.slice(0, hour.length - 3)
                                )
                            )
                                : []
                        } onChange={onChange} fieldErrors={fieldsErrors.time_visit}/>
                        <FormGroup labelValue={"Imię i Nazwisko"} inputType={"text"} inputName={"name_surname"}
                                   inputValue={fieldsValues.name_surname} onChange={onChange} required={true}

                        />
                        <FormGroup labelValue={"Telefon"} inputType={"tel"} inputMaxLength={9} inputName={"phone_number"}
                                   inputValue={fieldsValues.phone_number} onChange={onChange}
                                   required={true} errors={fieldsErrors.phone_number}
                        />
                        <FormGroup labelValue={"Marka i model"} inputType={"text"} inputName={"car_brand_model"}
                                   inputValue={fieldsValues.car_brand_model} onChange={onChange}
                                   required={true}
                        />
                        <FormGroup labelValue={"Tablice rejestracyjne"} inputType={"text"} inputMaxLength={8} inputName={"car_number"}
                                   inputValue={fieldsValues.car_number} onChange={onChange}
                                   required={true}
                        />
                        <FormGroup labelValue={"Data pierwszej rejestracji"}
                                   inputType={"date"} inputName={"car_first_registration"}
                                   inputValue={fieldsValues.car_first_registration} onChange={onChange}
                                   required={true}
                        />
                        <FormGroup labelValue={"Numer VIN"} inputType={"text"} inputMaxLength={17} inputName={"vin_number"}
                                   inputValue={fieldsValues.vin_number} onChange={onChange}
                                   required={true}
                        />
                        <FormGroup labelValue={"Krótki opis problemu"} inputType={"textarea"} inputName={"problem_description"}
                                   inputValue={fieldsValues.problem_description} onChange={onChange} required={true}
                        />
                        <div className={"d-grid"}>
                            <button className={"btn btn-success"}
                                    disabled={errorsArray.length > 0}
                                    type={"submit"}
                            >
                                Umówić się
                            </button>
                        </div>
                    </Form>
                </div>
            </div>
        </div>
    )
}
